// extracted by mini-css-extract-plugin
export default {"answer":"NH2PV","readOnlyAnswer":"QdGlX","orderWrapper":"dVat8","order":"MPIuB","line":"cIg5k","image":"SC77c","text":"pJfmE"};